// src/utils/socketUtils.js

/**
 * Ensures the STOMP client is connected.
 * If disconnected, attempts to activate it and waits up to 5 seconds.
 * * @param {Object} client - The STOMP client instance
 * @returns {Promise<boolean>} - Resolves true if connected, rejects with error if timeout
 */
export const ensureSocketConnection = (client) => {
  return new Promise((resolve, reject) => {
    // 1. If client is missing completely, we can't do anything
    if (!client) {
      return reject('WebSocket client not initialized.');
    }

    // 2. If already connected, resolve immediately
    if (client.connected) {
      return resolve(true);
    }

    console.log('Socket disconnected. Attempting to reconnect...');
    
    // 3. Force activation
    client.activate();

    // 4. Poll every 500ms to check if connected
    let attempts = 0;
    const maxAttempts = 10; // Wait up to 5 seconds (10 * 500ms)

    const interval = setInterval(() => {
      attempts++;
      
      if (client.connected) {
        clearInterval(interval);
        console.log('Socket reconnected successfully.');
        resolve(true);
      } else if (attempts >= maxAttempts) {
        clearInterval(interval);
        reject('Socket connection timed out after 5 seconds.');
      }
    }, 500);
  });
};